import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Stack,
} from '@chakra-ui/react';
import { FC } from 'react';
import { GetHelpArticlesResponse, HelpArticleInfo } from '@frx/frx-services';
import parse from 'html-react-parser';
import { Card } from '../../../components';
import { ChevronDown, ChevronRight } from '../../../assets';
import { getDataTracking } from '../../../utils';
import styles from './TipsAndSupport.module.scss';

export interface TipsAndSupportProps {
  helpArticlesData: GetHelpArticlesResponse['data']['informationalList']['items'];
}

export const TipsAndSupport: FC<TipsAndSupportProps> = ({
  helpArticlesData,
}): JSX.Element => (
  <Card w={['full', 'full', '356px']} py={6} px={[0, 0, 8]}>
    <>
      <Heading size="md" color="brand.primary.swatch1">
        Help Articles
      </Heading>

      {helpArticlesData.map((section, index) => (
        <Stack spacing={4} pt={6} key={`${section.sectionHeadline}-${index}`}>
          <Heading fontSize="md" color="brand.additional.black">
            {section.sectionHeadline}
          </Heading>

          <Accordion allowToggle>
            <Stack spacing={4}>
              {section.detailReference.map((article, id) => {
                const articleData = article as HelpArticleInfo;
                const title = articleData.mainHeading;
                const content = parse(articleData.primaryText.html || '');
                return (
                  <AccordionItem
                    borderBottomWidth="none"
                    borderWidth="1px"
                    borderColor="brand.primary.lightGrey"
                    borderRadius="4px"
                    key={`${title}-${id}`}
                  >
                    {({ isExpanded }) => (
                      <>
                        <AccordionButton
                          aria-label={title}
                          color="brand.secondary.swatch4"
                          fontWeight="semibold"
                          p={4}
                          _hover={{ background: 'transparent' }}
                          _focus={{ boxShadow: 'none' }}
                          {...getDataTracking(`${title}Button`)}
                        >
                          <Box flex="1" textAlign="left">
                            {title}
                          </Box>
                          {isExpanded ? (
                            <ChevronDown data-testid={`chevronDown${id}`} />
                          ) : (
                            <ChevronRight data-testid={`chevronRight${id}`} />
                          )}
                        </AccordionButton>
                        <AccordionPanel
                          className={styles.accordionPanel}
                          pb={4}
                        >
                          {content}
                        </AccordionPanel>
                      </>
                    )}
                  </AccordionItem>
                );
              })}
            </Stack>
          </Accordion>
        </Stack>
      ))}
    </>
  </Card>
);
